import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkle } from './Sparkle';
export function Calculator() {
  const [callsPerDay, setCallsPerDay] = useState(6);
  const [price, setPrice] = useState(2000);
  const [commission, setCommission] = useState(10);
  const [closingRate, setClosingRate] = useState(20);
  const [workDays, setWorkDays] = useState(22);
  const actualCalls = callsPerDay * 0.8;
  const salesPerDay = actualCalls * (closingRate / 100);
  const commissionPerSale = price * (commission / 100);
  const earningsPerDay = salesPerDay * commissionPerSale;
  const earningsPerMonth = earningsPerDay * workDays;
  const earningsPerYear = earningsPerMonth * 12;
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(value);
  };
  return <section id="rechner" className="relative w-full bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-127" data-mp="ubujhj8zdnss">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-128" data-mp="2ulvgbiiyx0fy" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-129" data-mp="2unq18wu8osk1" />
      <div className="relative z-10 mx-auto max-w-[1100px]" data-id="element-130" data-mp="2zjet0e00p55s">
        
        <div className="mx-auto max-w-3xl text-center" data-id="element-131" data-mp="2kwbvi7bp2wig">
          <h2 className="font-heading text-3xl font-extrabold uppercase leading-tight text-neutral-900 sm:text-4xl" data-id="element-132" data-mp="2ktppic4gcp2c">
            Wie viel kannst du als Hot Sales Girl verdienen?
          </h2>
          <p className="mt-6 text-sm leading-relaxed text-neutral-600 sm:text-base" data-id="element-133" data-mp="2btuafw7s09x1">
            <span className="block" data-id="element-134" data-mp="2fyadlpq0938k">
              Wir lieben diesen Rechner, weil er dir ganz transparent zeigt, was finanziell für dich
              möglich sein kann. Und das sind nicht nur irgendwelche Zahlen – solche Ergebnisse sind
              bereits Realität bei vielen erfolgreichen Teilnehmerinnen aus unserer Community.
            </span>
            <span className="mt-3 block" data-id="element-135" data-mp="54fm2l4h00oz">
              Spiel einfach selbst mit den Zahlen und sieh, wie schnell sich auch für dich finanziell
              etwas verändern kann.
            </span>
          </p>
        </div>

        <div className="mt-16 text-center" data-id="element-136" data-mp="3uss58cdw0zks">
          <div className="relative mx-auto inline-block" data-id="element-137" data-mp="3uvwevpa4gniu">
            <Sparkle className="animate-sparkle-delayed -left-7 top-1 h-6 w-6 sm:-left-9 sm:h-7 sm:w-7" data-id="element-138" data-mp="3pvs2obg8yeyf" />
            <Sparkle className="animate-sparkle-fast -right-6 bottom-1 h-4 w-4 sm:-right-8 sm:h-5 sm:w-5" data-id="element-139" data-mp="3kwxh51qwacam" />
            <h3 className="font-display text-xl font-extrabold uppercase leading-[1.15] text-hot-500 sm:whitespace-nowrap sm:text-3xl lg:text-4xl" style={{
            fontSize: "36px"
          }} data-id="element-140" data-mp="mdgvvp7rbmqf">
              Der Hot Sales Girls
              <br className="sm:hidden" data-id="element-141" data-mp="cmdwcruh7ft9" /> Verdienstrechner
            </h3>
          </div>
          <p className="mt-4 text-sm font-medium text-neutral-500" data-id="element-142" data-mp="7oklvmm53zn6">
            Nehme bei allen Rechnungen an, dass mit einer Show-Up-Rate von 80 % gerechnet wird.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-[1.15fr_1fr] items-stretch gap-3 sm:gap-8 lg:grid-cols-[1.2fr_1fr] lg:gap-12" data-id="element-143" data-mp="10c85ozfl6m8r">
          {/* Sliders */}
          <div className="flex flex-col gap-5 rounded-2xl bg-white p-4 shadow-xl sm:gap-8 sm:rounded-[2rem] sm:p-8" data-id="element-144" data-mp="1cnr0bve9iwtr">
            <div data-id="element-145" data-mp="1hmu6jj5zb93b">
              <div className="mb-1 flex items-center justify-between" data-id="element-146" data-mp="1hmc2w1gzlsld">
                <label htmlFor="calls" className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-147" data-mp="1mmq0sqovjm5o">
                  Closingcalls pro Tag
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-148" data-mp="1rjgpu3inps38">{callsPerDay}</span>
              </div>
              <p className="mb-3 text-[10px] text-neutral-500 sm:text-xs" data-id="element-149" data-mp="20d38qt1rn0v0">Range: 1 – 6 Calls/Tag • Es werden automatisch 80 % Show-Up angesetzt</p>
              <input id="calls" type="range" min="1" max="6" step="1" value={callsPerDay} onChange={e => setCallsPerDay(Number(e.target.value))} onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} className="h-2 w-full cursor-pointer touch-none select-none rounded-full bg-neutral-200 accent-hot-500 outline-none" data-id="element-150" data-mp="25bwlgj98anu4" />
            </div>

            <div data-id="element-151" data-mp="3gtr545ke0apw">
              <div className="mb-1 flex items-center justify-between" data-id="element-152" data-mp="3gvbp5192sb9i">
                <label htmlFor="price" className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-153" data-mp="2t3ws9o02im5n">
                  Preis des Coachings
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-154" data-mp="324bhgyg5klef">
                  {formatCurrency(price)}
                </span>
              </div>
              <p className="mb-3 text-[10px] text-neutral-500 sm:text-xs" data-id="element-155" data-mp="hdkfvjp2moo6">in € (2.000 – 10.000)</p>
              <input id="price" type="range" min="2000" max="10000" step="500" value={price} onChange={e => setPrice(Number(e.target.value))} onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} className="h-2 w-full cursor-pointer touch-none select-none rounded-full bg-neutral-200 accent-hot-500 outline-none" data-id="element-156" data-mp="dciqrvovbszx" />
            </div>

            <div data-id="element-157" data-mp="18lchk3dvqgw5">
              <div className="mb-1 flex items-center justify-between" data-id="element-158" data-mp="18lvuf5ooaf3b">
                <label className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-159" data-mp="twg39ol8c7n3">
                  Provision
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-160" data-mp="yuhly8equ4y1">{commission} %</span>
              </div>
              <div className="mt-3 flex gap-1.5 sm:gap-3" data-id="element-161" data-mp="1mjsrs4ayapj1">
                {[10, 15, 20].map(val => <button key={val} onClick={() => setCommission(val)} className={`flex-1 rounded-full py-1.5 text-[11px] font-semibold transition-colors sm:py-2 sm:text-sm ${commission === val ? 'bg-hot-500 text-white' : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'}`} data-id="element-162" data-mp="1rdwxkk8hcrij">
                    {val} %
                  </button>)}
              </div>
            </div>

            <div data-id="element-163" data-mp="1dh6u0yn29qg1">
              <div className="mb-3 flex items-center justify-between" data-id="element-164" data-mp="1dgorxldpwi07">
                <label htmlFor="closingRate" className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-165" data-mp="18idd0w8kfhb4">
                  Closingrate
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-166" data-mp="zigwxj08rqro">{closingRate} %</span>
              </div>
              <input id="closingRate" type="range" min="10" max="70" step="1" value={closingRate} onChange={e => setClosingRate(Number(e.target.value))} onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} className="h-2 w-full cursor-pointer touch-none select-none rounded-full bg-neutral-200 accent-hot-500 outline-none" data-id="element-167" data-mp="uj40q7nhd7cf" />
            </div>

            <div data-id="element-168" data-mp="2sgds6ugyt5rc">
              <div className="mb-1 flex items-center justify-between" data-id="element-169" data-mp="2sfu93afkwbbq">
                <label htmlFor="workDays" className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-170" data-mp="2wgo22i7vogbh">
                  Arbeitstage pro Monat
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-171" data-mp="24pzzd1qk32vp">{workDays} Tage</span>
              </div>
              <p className="mb-3 text-[10px] text-neutral-500 sm:text-xs" data-id="element-172" data-mp="28qa4kc6ixp9i">1 – 30 Tage/Monat</p>
              <input id="workDays" type="range" min="1" max="30" step="1" value={workDays} onChange={e => setWorkDays(Number(e.target.value))} onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} className="h-2 w-full cursor-pointer touch-none select-none rounded-full bg-neutral-200 accent-hot-500 outline-none" data-id="element-173" data-mp="1237u26igxbt7" />
            </div>
          </div>

          {/* Results */}
          <div className="flex flex-col justify-center rounded-2xl bg-gradient-to-b from-hot-50 to-[#eeb4d0] p-4 shadow-xl sm:rounded-[2rem] sm:p-8" data-id="element-174" data-mp="1urwyofiqfz9p">
            <div className="space-y-5 sm:space-y-8" data-id="element-175" data-mp="23slad3knlnjf">
              <div data-id="element-176" data-mp="23ra8xaeokrvh">
                <p className="text-[10px] font-semibold uppercase tracking-wider text-hot-600 sm:text-sm" data-id="element-177" data-mp="1zrriy0805qls">
                  Dein Verdienst pro Tag
                </p>
                <p className="font-heading mt-1 text-xl font-extrabold text-neutral-900 sm:text-4xl" data-id="element-178" data-mp="2iguzqhq9yvhc">
                  {formatCurrency(earningsPerDay)}
                </p>
              </div>
              <div className="h-px w-full bg-hot-200/50" data-id="element-179" data-mp="29f3xxnyuv8sr" />
              <div data-id="element-180" data-mp="2edozbqpufyis">
                <p className="text-[10px] font-semibold uppercase tracking-wider text-hot-600 sm:text-sm" data-id="element-181" data-mp="2ed5fg4gmv024">
                  Dein Verdienst pro Monat (× {workDays} Tage)
                </p>
                <p className="font-heading mt-1 text-2xl font-extrabold text-hot-600 sm:text-5xl lg:text-6xl" data-id="element-182" data-mp="24hc60ty7nmok">
                  {formatCurrency(earningsPerMonth)}
                </p>
              </div>
              <div className="h-px w-full bg-hot-200/50" data-id="element-183" data-mp="1uriutu1zd9ku" />
              <div data-id="element-184" data-mp="1gqpwszcgzwcz">
                <p className="text-[10px] font-semibold uppercase tracking-wider text-hot-600 sm:text-sm" data-id="element-185" data-mp="1gq6j5uturu4r">
                  Dein Verdienst pro Jahr (× 12 Monate)
                </p>
                <div className="relative inline-block" data-id="element-186" data-mp="4s5myqaph52q">
                  <Sparkle className="animate-sparkle -left-4 -top-2 h-4 w-4 sm:-left-6 sm:h-6 sm:w-6" data-id="element-187" data-mp="4qm54v9eilyu" />
                  <p className="font-heading mt-1 text-xl font-extrabold text-neutral-900 sm:text-4xl" data-id="element-188" data-mp="8uty54mw6o2v">
                    {formatCurrency(earningsPerYear)}
                  </p>
                </div>
              </div>
            </div>
            
            <div className="mt-5 rounded-xl bg-white/40 p-3 text-center text-[10px] font-medium leading-relaxed text-neutral-800 backdrop-blur-sm sm:mt-8 sm:p-4 sm:text-xs" data-id="element-189" data-mp="nhvixgq7fww8">
              {actualCalls.toFixed(1).replace('.', ',')} Calls/Tag (anwesend) • Ø Ticket: {formatCurrency(price)} • Provision: {commission} % • Monatstage: {workDays}
            </div>
          </div>
        </div>
        
        <p className="mx-auto mt-8 max-w-4xl text-center text-xs leading-relaxed text-neutral-500" data-id="element-190" data-mp="16gr82dn7hl37">
          Disclaimer: Dieser Verdienstrechner dient ausschließlich als Rechenbeispiel. Ergebnisse sind nicht garantiert und hängen von individuellen Fähigkeiten, Marktbedingungen, Lead-Qualität, No-Shows, Zahlungsmodalitäten u. v. m. ab.
        </p>
      </div>
    </section>;
}